import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchSubDashboardList = createAsyncThunk("fetchSubDashboardList", async ({ page, limit, filters }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const params = new URLSearchParams({
		page: page,
		limit: limit,
		keyword: filters?.keyword ?? "",
	});

	const response = await axiosHttp.get(`analytics/subdashboard/list?${params}`, config);
	return response.data.data;
});

const SubDashboardListSlice = createSlice({
	name: "SubDashboardListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchSubDashboardList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchSubDashboardList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});
		builder.addCase(fetchSubDashboardList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default SubDashboardListSlice.reducer;
